import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { FileCopy } from "@mui/icons-material";

const DnsCopyField = ({
  label,
  value,
  copyValue,
  hint,
  copyTooltip,
  onCopy,
}) => (
  <Box sx={{ mt: 1.5 }}>
    <Typography
      variant="body2"
      component="div"
      sx={{ fontWeight: 500, mb: 0.5, color: "text.primary" }}
    >
      {label}
    </Typography>
    <Box display="flex" alignItems="center" gap={0.5}>
      <Box
        component="code"
        p={1}
        sx={{
          backgroundColor: "#f5f5f5",
          wordBreak: "break-all",
          flexGrow: 1,
          display: "block",
        }}
      >
        {value}
      </Box>
      <Tooltip title={copyTooltip || `Copy ${label}`}>
        <IconButton
          size="small"
          onClick={() => onCopy(copyValue ?? value)}
          aria-label={copyTooltip || `Copy ${label}`}
        >
          <FileCopy fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
    {hint ? (
      <Typography
        variant="caption"
        component="div"
        sx={{ mt: 0.5, color: "text.secondary", lineHeight: 1.4 }}
      >
        {hint}
      </Typography>
    ) : null}
  </Box>
);

export default DnsCopyField;
